<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm02">
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="xrefInternal"><a href="#/contents#fm_02"><span class="bold">TABLE OF MONEY VALUES</span></a></span></h2>
</div>
<div class="chapterBody">
<p class="paraCenter1">1 florin [or gulden] = 60 kreuzer</p>
<p class="paraCenter1">1 ducat = 4 1/2 florins</p>
<p class="paraCenter1">1 Reichsthaler = 1 1/2 florins</p>
<p class="paraCenter1">1 friedrich d’or = 7 to 8 florins</p>
<p class="paraCenter1">1 sequin = 2.8 florins</p>
<p class="paraCenter1">1 English shillings = 1 florin</p>
<p class="paraCenter1">1 English pound ="10" florins</p>
<p class="paraCenter1">1 louis d’or = 9 to 10 florins</p>
<p class="spaceBreak"> </p>
<p class="paraCenter">Rates vary somewhat owing to currency fluctuations.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tableof.vue?499f8532